import { useEffect, useState, useRef } from "react";
import { authFetch } from "../utils/authFetch";
import { useUserAPI } from "../contexts/UserAPIContext";

const ListaAvisos = () => {
  const [avisos, setAvisos] = useState([]);
  const abortController = useRef(null);
  const { userAPIData } = useUserAPI();

  useEffect(() => {
    // Create a new AbortController for this cycle
    abortController.current = new AbortController();

    const fetchAvisos = async () => {
      if (!userAPIData || !userAPIData.id) return;

      try {
        const queryParams = new URLSearchParams();
        queryParams.append('userId', userAPIData.id);
        
        const url = `notification/0/20?${queryParams.toString()}`;
        const response = await authFetch(url, {
          signal: abortController.current.signal
        });

        if (!response.ok) throw new Error();

        const data = await response.json();

        // Ordena por nível de notificação: 1 primeiro
        const avisosList = data.content || [];
        const ordenado = avisosList.sort((a, b) => b.notificationLevel - a.notificationLevel);
        setAvisos(ordenado);
      } catch (error) {
        // Don't show error if request was aborted
        if (error.name === 'AbortError') return;
        console.error("Erro ao carregar avisos", error);
      }
    };

    fetchAvisos();

    // Cleanup: abort the request when component unmounts
    return () => {
      if (abortController.current) {
        abortController.current.abort();
      }
    };
  }, [userAPIData]);

  return (
    <div className="col-lg-12 col-md-12 mb-md-0 mb-4">
      <div className="card card-dashboard-20" style={{ borderRadius: '12px' }}>
        <div className="card-header pb-0">
          <div className="row">
            <div className="col-lg-6 col-7">
              <h6 className="mb-2 font-weight-bolder" style={{ marginBottom: '0.75rem' }}>Quadro de Avisos</h6>
            </div>
          </div>
        </div>
        <div className="card-body px-0 pb-2">
          <div className="table-responsive">
            <table className="table align-items-center mb-0">
              <thead>
                <tr>
                  <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Aviso
                  </th>
                </tr>
              </thead>
              <tbody>
                {avisos.map((aviso) => (
                  <tr key={aviso.id}>
                    <td className="text-xs mb-0">
                      <div className="d-flex px-2 py-1">
                        <div className="d-flex flex-column justify-content-center">
                          <i
                            className="fa-solid fa-note-sticky text-primary text-gradient"
                            style={{ marginRight: "3px" }}
                          ></i>
                        </div>
                        <div className="d-flex flex-column justify-content-center">
                          <p
                            className={`mb-0 text-sm ${
                              aviso.notificationLevel === 1 ? "aviso-importante" : ""
                            }`}
                            style={{ fontSize: '1.26rem' }}
                          >
                            {aviso.description}
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
                {avisos.length === 0 && (
                  <tr>
                    <td className="text-center py-3 text-sm">Nenhum aviso encontrado</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListaAvisos;
